import { render, staticRenderFns } from "./upImgnew.vue?vue&type=template&id=5a7a7e0a&scoped=true"
import script from "./upImgnew.vue?vue&type=script&lang=js"
export * from "./upImgnew.vue?vue&type=script&lang=js"
import style0 from "./upImgnew.vue?vue&type=style&index=0&id=5a7a7e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7a7e0a",
  null
  
)

export default component.exports